import React, { useRef, useEffect, useState, useContext } from "react";
import "./bookPreview.styles.css";
import SmallLogo from "../../assets/images/dark-logo.png";
import { useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { AppContext } from "../../context/AppContext";
import { motion } from "framer-motion"
import AnimationSpinner from "../../AnimationSpinner";

import {
	FaArrowDown,
	FaArrowLeft,
	FaArrowRight,
	FaShareSquare,
	FaFacebook,
	FaTwitter,
	FaWhatsapp,
	FaLinkedin,
	FaTelegram,
	FaFacebookMessenger,
	FaReddit,
	FaEnvelope,
	FaGetPocket,
	FaTumblr,
	FaBlogger,
} from "react-icons/fa";
import { toast } from "react-toastify";
const FlipBookPreview = () => {
	const hiddenDivRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);
	const { base_url } = useContext(AppContext);
	const { slug } = useParams();
	const [bookDetails, setBookDetails] = useState('');
	const [loading, setLoading] = useState(false);
	//model states
	const [modalActive, setModalActive] = useState(false);
	const modalRef = useRef(null);


	var shareBookURL = `${window.location.origin}/flipbook/${slug}`;

	const socialPlatforms = [
		{ name: "Facebook", icon: <FaFacebook />, color: "#1877F2", link: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareBookURL)}` },
		{ name: "Twitter", icon: <FaTwitter />, color: "#1DA1F2", link: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareBookURL)}` },
		{ name: "WhatsApp", icon: <FaWhatsapp />, color: "#25D366", link: `https://api.whatsapp.com/send?text=${encodeURIComponent(shareBookURL)}` },
		{ name: "LinkedIn", icon: <FaLinkedin />, color: "#0A66C2", link: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareBookURL)}` },
		{ name: "Telegram", icon: <FaTelegram />, color: "#26A5E4", link: `https://t.me/share/url?url=${encodeURIComponent(shareBookURL)}` },
		{ name: "Messenger", icon: <FaFacebookMessenger />, color: "#0084FF", link: `https://www.facebook.com/dialog/send?link=${encodeURIComponent(shareBookURL)}&app_id=YOUR_APP_ID&redirect_uri=${encodeURIComponent(window.location.origin)}` },
		{ name: "Reddit", icon: <FaReddit />, color: "#FF4500", link: `https://www.reddit.com/submit?url=${encodeURIComponent(shareBookURL)}` },
		{ name: "Gmail", icon: <FaEnvelope />, color: "#EA4335", link: `mailto:?subject=Check this out&body=${encodeURIComponent(shareBookURL)}` },
		{ name: "Pocket", icon: <FaGetPocket />, color: "#EF3F56", link: `https://getpocket.com/edit?url=${encodeURIComponent(shareBookURL)}` },
		{ name: "Tumblr", icon: <FaTumblr />, color: "#36465D", link: `https://www.tumblr.com/share/link?url=${encodeURIComponent(shareBookURL)}` },
		{ name: "Blogger", icon: <FaBlogger />, color: "#FF8000", link: `https://www.blogger.com/blog-this.g?u=${encodeURIComponent(shareBookURL)}` },
		{ name: "Outlook", icon: <FaEnvelope />, color: "#0078D4", link: `mailto:?subject=Check this out&body=${encodeURIComponent(shareBookURL)}` },
	]

	const modalVariants = {
		hidden: { opacity: 0, scale: 0.9 },
		visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
		exit: { opacity: 0, scale: 0.9, transition: { duration: 0.4 } },
	};
	const handleModelCloseClick = (event) => {
		if (event.target.classList.contains("history-image-model")) {
			closeModal();
		}
	};
	const closeModal = () => {
		setModalActive(false);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (modalRef.current && !modalRef.current.contains(event.target)) {
				closeModal();
			}
		};

		if (modalActive) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [modalActive]);

	const handleShare = (link) => {
		if (link) {
			window.open(link, "_blank");
		}
	}

	const fetchPageData = async () => {
		try {
			setLoading(true);
			const formData = new FormData();
			formData.append("book_token", slug);
			const { data } = await axios.post(`${base_url}bookflow/viewer`, formData);
			if (data.status) {
				setBookDetails(data.res.book);
			} else {
				toast.warning(data.message);
				// Swal.fire({
				// 	icon: "warning",
				// 	title: "Warning",
				// 	text: data.message,
				// });
			}
		} catch (error) {
			toast.error(error.response?.data?.message ||
				error.message ||
				"Something went wrong. Please try again.");
			// Swal.fire({
			// 	icon: "error",
			// 	title: "Error",
			// 	text:
			// 		error.response?.data?.message ||
			// 		error.message ||
			// 		"Something went wrong. Please try again.",
			// });
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchPageData();
	}, []);


	return (
		<>
			<AnimationSpinner show={loading} />
			{modalActive && (
				<div
					className="history-image-model social shadow rounded position-absolute"
					ref={modalRef}
					onClick={handleModelCloseClick}
				>
					<motion.div
						className="model-body position-relative"
						initial={{ opacity: 0, y: -20 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: 20 }}
						transition={{ duration: 0.3 }}
					>
						<main
							className="d-flex justify-content-center align-items-center"
							style={{ width: "600px" }}
						>
							<div
								className="container-fluid p-4"
								style={{
									backgroundColor: "rgb(245, 248, 251)",
									maxWidth: "800px",
									borderRadius: "8px",
								}}
							>
								<div className="row row-cols-1 row-cols-md-3 g-3">
									{socialPlatforms.map((platform) => (
										<div className="col" key={platform.name}>
											<button
												onClick={() => handleShare(platform.link)}
												className="btn d-flex align-items-center w-100 text-white"
												style={{
													backgroundColor: platform.color,
													border: "none",
													padding: "8px 12px",
												}}
											>
												<span className="me-2" style={{ fontSize: "1.2rem" }}>
													{platform.icon}
												</span>
												<span className="small fw-medium">{platform.name}</span>
											</button>
										</div>
									))}
								</div>
							</div>
						</main>
					</motion.div>
				</div>
			)}
			<div
				className="d-flex flex-column justify-content-center align-items-center flipbook-preview"
				style={{
					height: "100vh",
					width: "100vw",
					backgroundColor: "rgb(255 55 200 / 10%)",
				}}
			>
				<iframe
					width="100%"
					height="100%"
					allowFullScreen
					className="fp-iframe"
					style={{ marginBottom: '71px' }}
					src={`https://heyzine.com/api1?pdf=${bookDetails.pdf_file}&d=0&k=f3c5aa9016acf22e`}>
				</iframe>


				{/* <iframe width="50%" height="80%" allowfullscreen="allowfullscreen" class="fp-iframe" src="https://heyzine.com/api1?pdf=https://app.liveluckier.com/mobilenumerology/backend/uploads/reports/client_report_19.pdf&t=dfggdfgdf&d=0&k=f3c5aa9016acf22e"></iframe> */}


				<div
					className={`bottom-nav d-flex align-items-center justify-content-between  ${isOpen ? "" : "	"
						}`}
				>
					{/*<div className="col-lg-2">
						<div className={`site-logo_ ${isOpen ? "d-none" : ""}`}>
							<a href="" target="_blank">
								<img
									src={SmallLogo}
									class="img"
									alt="Logo"
									width={200}
									height={40}
								/>
							</a>
						</div>
					</div>*/}
					<div className="col-lg-10">
						<div
							className={`footer-page-title text-right d-flex align-items-center justify-content-center gap-2`}
						>

							<h4
								className="title mb-0"
								style={{
									fontSize: "18px",
									color: "currentcolor",
									fontWeight: "600",
								}}
							>
								{bookDetails.title}
							</h4>
						</div>
					</div>
					<div className="col-lg-2 text-end">
						<button
							onClick={() => setModalActive(true)}
							className="action-btn shadow-lg rounded border border-1 border-black-200 p-2 px-3 btn-outline-none preview-share-btn">
							<FaShareSquare size={18} />
						</button>
					</div>
				</div>
			</div>
		</>
	);
};

export default FlipBookPreview;
